export default "__VITE_ASSET__$2$5qJ7i__"